import api from './axios';

export const exportPedidos = (formato, filtros = {}) =>
  api.get('/relatorios/pedidos/export', { params: { formato, ...filtros }, responseType: 'blob' });
